// src/app/redux/sagas/jobSkillSaga.js

import { call, put } from "redux-saga/effects";
import Swal from "sweetalert2";
import {
    fetchJobSkillsRequest,
    fetchJobSkillsSuccess,
    fetchJobSkillsFail,
    createJobSkillSuccess,
    createJobSkillFail,
    updateJobSkillSuccess,
    updateJobSkillFail,
    deleteJobSkillSuccess,
    deleteJobSkillFail,
    setJobSkillLoading,
} from "../actions/jobSkillActions";

import { API_BASE_URL, getRequest, postRequest, putRequest, deleteRequest } from "../../../api";

const getUid   = () => sessionStorage.getItem("uid");
const getToken = () => sessionStorage.getItem("token");

export function* fetchJobSkillsSaga(action) {
    const { jobId } = action.payload;
    const url   = `${API_BASE_URL}/api/job-skills/job/${jobId}`;
    const uid   = getUid();
    const token = getToken();

    yield put(setJobSkillLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid, token });
        yield put(fetchJobSkillsSuccess(resp.data));
    } catch (e) {
        yield put(fetchJobSkillsFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setJobSkillLoading(false));
    }
}

export function* createJobSkillSaga(action) {
    const url   = `${API_BASE_URL}/api/job-skills`;
    const uid   = getUid();
    const token = getToken();

    yield put(setJobSkillLoading(true));
    try {
        const resp = yield call(postRequest, { url, data: action.payload, uid, token });
        yield put(createJobSkillSuccess(resp.data));
        yield put(fetchJobSkillsRequest(action.payload.jobId));
        yield call([Swal, Swal.fire], { icon: "success", text: "Compétence ajoutée au poste", timer: 1500, showConfirmButton: false });
    } catch (e) {
        yield put(createJobSkillFail(e.response?.data?.message || e.message));
        yield call([Swal, Swal.fire], { icon: "error", text: e.response?.data?.message || "Erreur ajout compétence", timer: 1800, showConfirmButton: false });
    } finally {
        yield put(setJobSkillLoading(false));
    }
}

export function* updateJobSkillSaga(action) {
    const { id, payload } = action.payload;
    const url   = `${API_BASE_URL}/api/job-skills/${id}`;
    const uid   = getUid();
    const token = getToken();

    yield put(setJobSkillLoading(true));
    try {
        const resp = yield call(putRequest, { url, data: payload, uid, token });
        yield put(updateJobSkillSuccess(resp.data));
        yield put(fetchJobSkillsRequest(payload.jobId));
        yield call([Swal, Swal.fire], { icon: "success", text: "Niveau modifié", timer: 1500, showConfirmButton: false });
    } catch (e) {
        yield put(updateJobSkillFail(e.response?.data?.message || e.message));
        yield call([Swal, Swal.fire], { icon: "error", text: e.response?.data?.message || "Erreur modification niveau", timer: 1800, showConfirmButton: false });
    } finally {
        yield put(setJobSkillLoading(false));
    }
}

export function* deleteJobSkillSaga(action) {
    const { id } = action.payload;
    const url   = `${API_BASE_URL}/api/job-skills/${id}`;
    const uid   = getUid();
    const token = getToken();

    yield put(setJobSkillLoading(true));
    try {
        yield call(deleteRequest, { url, uid, token });
        yield put(deleteJobSkillSuccess(id));
        yield call([Swal, Swal.fire], { icon: "success", text: "Compétence supprimée du poste", timer: 1500, showConfirmButton: false });
    } catch (e) {
        yield put(deleteJobSkillFail(e.response?.data?.message || e.message));
        yield call([Swal, Swal.fire], { icon: "error", text: "Erreur suppression compétence", timer: 1800, showConfirmButton: false });
    } finally {
        yield put(setJobSkillLoading(false));
    }
}